import React from 'react';

/**
 * Dropshop menu icon: a single minimalist drop outline with a small inner highlight.
 * Drawn on the same 24px grid, stroke and round caps as the lucide icons beside it, and
 * it takes the same `size` / `strokeWidth` props, so the menus keep their layout unchanged.
 * `currentColor` means it follows the menu text colour in both the light and dark theme.
 */
interface DropshopIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string;
  strokeWidth?: number | string;
}

const DropshopIcon: React.FC<DropshopIconProps> = ({ size = 24, strokeWidth = 2, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
    {...rest}
  >
    <path d="M12 3.5c-3.2 3.9-6 7.2-6 10.4a6 6 0 0 0 12 0c0-3.2-2.8-6.5-6-10.4Z" />
    <path d="M9.4 14.2a2.6 2.6 0 0 0 2.1 2.4" />
  </svg>
);

export default DropshopIcon;
